"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.index-of.js");

/**
 * @function LoadJS - 动态加载js文件
 * @param {string} url 资源地址
 * @param {function} [cb] callback函数
 * @param {boolean} [isAsync=false] 是否异步
 */
var hasLoadJsArr = [];

var loadJS = function loadJS(url, cb) {
  var isAsync = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // 已加载过不需要再次加载
  if (hasLoadJsArr.indexOf(url) !== -1) {
    if (cb) {
      cb();
    }

    return;
  }

  var head = window.document.getElementsByTagName('body')[0];
  var js = window.document.createElement('script');
  js.setAttribute('type', 'text/javascript');
  js.setAttribute('async', 'async');
  js.setAttribute('src', url);

  js.onload = function () {
    hasLoadJsArr.push(url);

    if (cb && !isAsync) {
      cb();
    }
  };

  head.appendChild(js);
};

var _default = loadJS;
exports["default"] = _default;